import React, { useEffect, useState, useMemo } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import ListView from "../../../shared/components/listview/ListView";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CREATENEW, IMPORT, CHATGROUPS } from "../../../shared/constants/Constants";
import dropdownFilterFunction from '../../../shared/components/listview/dropdownFilterFunction';
import Modalpopup from "../../../shared/components/Modalpopup";
import DeleteModal from "../../../shared/components/DeleteModal";
import ImportModal from "../../../shared/components/ImportModal";
import Permissions from "../../../shared/components/Permissions";
import { loadChatGroupDataRequest } from "../redux/Actions";
import Members from "./Members";


const ChatGroups = () => {
    let dispatch = useDispatch();
    let navigate = useNavigate();    
    const [showMembersModel, setShowMembersModal] = useState(false);
    let [selectedRow, setSelectedRow] = useState({})
    let chatgroups = useSelector((state) => state.chatgroup);
    let chats = chatgroups.chatgroup;
    let typeOptions = useMemo(() => {
        let uniqueTypes = [...new Set(chats.map((chat) => chat.type))];
        return uniqueTypes.map((type) => ({ value: type, label: type })); 
    }, [chats]);
    let typeFunc = dropdownFilterFunction(typeOptions);
    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "chat_group";
    let permission = Permissions(emp_no, module_name);

    let executionTypes = useMemo(() => {
        let uniqueExecutionTypes = [...new Set(chats.map((chat) => chat.executionType))];
        return uniqueExecutionTypes.map((executionType) => ({ value: executionType, label: executionType }));
    }, [chats]);
    
    let executionTypeFunc = dropdownFilterFunction(executionTypes);   

    console.log("chatgroups.chatgroup", chatgroups.chatgroup);


    let columns = [
        {
            display_name: "id",
            field: "id",
            type: "number",
            hide: true
        },
        {
            display_name: "Name",
            field: "chat_name",
            type: "text",
        }, 
        {
            display_name: "Type",
            field: "type",
            type: "dropdown",
            dropdownOptions: typeOptions.map(option => option.value),
            dropdownFunction: typeFunc,
        
        },
        {
            display_name: "Execution Type",
            field: "executionType",
            type: "dropdown",
            dropdownOptions: executionTypes.map(option => option.value),
            dropdownFunction: executionTypeFunc,
        
        },
        {
            display_name: "Users",
            field: "no_of_active_participants",
            type: "number ",
        },
        {
            display_name: "Messages",
            field: "message_count",
            type: "number ",
        },
        {
            display_name: "Created On",
            field: "createdAt",
            type: "date",
        },
        
    ];

    console.log("Selected",selectedRow.data);
    
    const handleRowClick = (Row) => {        
        setSelectedRow(Row);
        console.log("Selected", selectedRow.data);
        setTimeout(() => setShowMembersModal(true), 100);    };

    useEffect(() => {            
        dispatch(loadChatGroupDataRequest("all"));    
    }, []);
    
     console.log(chatgroups.chatgroup);
    
    return (
        <>
            <Row>
                <Col className="gx-0">
                    <Breadcrumbs
                        children={[
                            { href: '/chatlogs', label: CHATGROUPS },
                        ]}
                    />
                </Col>                 
            </Row>
            <Row>
                <Card>
                    <Card.Body>
                        <ListView
                            exportTitle={CHATGROUPS}
                            columnNames={columns}   
                            rowData={chatgroups.chatgroup}
                            rowClick={handleRowClick} 
                        />
                    </Card.Body>
                </Card>
            </Row>
            <Modalpopup height="80vh" size={'lg'} show={showMembersModel} handleClose={() => setShowMembersModal(false)} title="Group Members">
              <div style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
              <Members selectedRow={selectedRow} />
              </div>
            </Modalpopup>
  
            
            
        </>
    );
};
  
export default ChatGroups;
